import { CartesianGrid } from 'recharts';

// @ts-ignore
CartesianGrid.defaultProps.stroke = '#dee3e5';
// @ts-ignore
CartesianGrid.defaultProps.vertical = false;

export { CartesianGrid };
